import React from 'react';
import {Text, StyleSheet, TouchableOpacity} from 'react-native';
import Themes from '../../themes';

const Button = ({label, type, onPress, img}) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <Text style={styles.text}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: Themes.colors.blue,
  },
  text: {
    fontSize: 20,
    color: '#FFF',
    fontFamily: 'Roboto-Black',
  },
});

export default Button;
